import styled, { css } from 'styled-components'

import { ArrowLeftIcon } from '../icons'
import { mediaMinTablet } from '../theme'

const NUMBERS = Array.from({ length: 9 })
  .fill(undefined)
  .map((_, idx) => idx + 1)

type PinKeyboardProps = {
  onInput?: (digit: string) => void
  onRemove?: () => void
}

export const PinKeyboard: React.FC<PinKeyboardProps> = ({
  onInput,
  onRemove,
}) => {
  return (
    <Root>
      {NUMBERS.map((digit) => (
        <ButtonRoot key={digit} onClick={() => onInput?.(digit.toString())}>
          {digit}
        </ButtonRoot>
      ))}
      <div></div>
      <ButtonRoot onClick={() => onInput?.('0')}>0</ButtonRoot>
      <ButtonRoot onClick={onRemove}>
        <ArrowLeftIcon />
      </ButtonRoot>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: repeat(3, auto);
  grid-template-rows: repeat(4, auto);
  grid-gap: 24px;

  ${mediaMinTablet(css`
    grid-gap: 32px;
  `)}
`

const ButtonRoot = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  font-weight: 400;
  font-size: 28px;
  text-align: center;
  color: var(--text-12);

  border: 1px solid rgba(255, 255, 255, 0.17);

  &:active {
    background: rgba(255, 255, 255, 0.1);
  }

  ${mediaMinTablet(css`
    width: 90px;
    height: 90px;
  `)}
`
